// extracted by mini-css-extract-plugin
export default {"header":"Header_header__nXScI","header-text":"Header_header-text__fSRjk","header-text1":"Header_header-text1__6lYcl"};